import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { isMobile, numberAttr, prefersReducedMotion, qsa } from '@/lib/dom'

/**
 * `data-y` を持つ要素をスクロール量に連動して縦方向へ動かす。
 *
 *  - `.js-MvParallax` … メインビジュアル周辺。ビューポート先頭を基準に動かす。
 *  - `.js-parallax`   … 各セクションの背景・写真。要素が画面に入ってから出るまでを区間にする。
 *
 * `sp-noParallax` が付いた要素は SP では動かさない（CSS 側の指定と揃える）。
 */
export function initParallax(): void {
  if (prefersReducedMotion()) return

  const mobile = isMobile()

  const apply = (elements: HTMLElement[], mode: 'viewport' | 'element'): void => {
    elements.forEach((el) => {
      if (mobile && el.classList.contains('sp-noParallax')) return

      const distance = numberAttr(el, 'data-y', 0)
      if (distance === 0) return

      gsap.fromTo(
        el,
        { y: 0 },
        {
          y: distance,
          ease: 'none',
          scrollTrigger: {
            trigger: mode === 'viewport' ? document.body : el,
            start: mode === 'viewport' ? 'top top' : 'top bottom',
            end: mode === 'viewport' ? 'bottom bottom' : 'bottom top',
            scrub: true,
            invalidateOnRefresh: true,
          },
        },
      )
    })
  }

  apply(qsa<HTMLElement>('.js-MvParallax'), 'viewport')
  apply(qsa<HTMLElement>('.js-parallax'), 'element')

  ScrollTrigger.refresh()
}
